export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 3.25a.75.75 0 01.75.75v.298c2.821.368 5 2.78 5 5.702 0 1.223.003 2.137.23 3.112.225.962.679 2.024 1.644 3.472A.75.75 0 0119 17.75h-3.325a3.751 3.751 0 01-7.35 0H5a.75.75 0 01-.624-1.166c.965-1.448 1.42-2.51 1.644-3.472.227-.975.23-1.89.23-3.112a5.751 5.751 0 015-5.702V4a.75.75 0 01.75-.75zm-2.122 14.5a2.25 2.25 0 004.244 0H9.878zM12 5.75A4.25 4.25 0 007.75 10v.04c0 1.18 0 2.255-.27 3.412-.203.871-.552 1.767-1.135 2.798h11.31c-.583-1.031-.932-1.927-1.135-2.798-.27-1.157-.27-2.231-.27-3.412V10A4.25 4.25 0 0012 5.75z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};